<template>
    <div data-component="stratmk.prod-dets.v12020" class="max">
        <div class="close-btn text-center">
            <v-btn rounded text @click="killDialog()">
                <i class="las la-times white--text" style="font-size: 34px"></i>
            </v-btn>
        </div>
        <div class="breadcrum text-center">
            <span class="dolo t20 white--text">{{prod.title}}</span>
        </div>
        <prod-vid v-if="prod.detType == 'vid'" :type="prod.type" :prod="prod"  :launched="launched" @killProdDialog="killDialog()" />
        <prod-pro v-if="prod.detType == 'promo'" :type="prod.type" :prod="prod" :launched="launched"  @killProdDialog="killDialog()" />
    </div>
</template>

<script>
import prodVid from '../components/prod-vid'
import prodPro from '../components/prod-promo'

export default {
    components: {
        prodVid,
        prodPro
    },
    props: {
        prod: Object,
        launched: Boolean,
    },
    data: () => {
        return {

        }
    },
    methods: {
        killDialog(){
            this.$emit('killProdDialog')
        }
    }
}
</script>

<style lang="scss" scoped>
    .det-sec1 {
        height: 90vh;
        overflow: hidden;

        .vid-bg {
            position: absolute;
            height: 90vh;
            left: 0;
            top: 0;
            width: 100%;
            opacity: .94;
            z-index: 0;
        }

        .vid-overlay {
            position: absolute;
            height: 90vh;
            left: 0;
            top: 0;
            width: 100%;
            opacity: .64; 
            z-index: 1;
        }

        .logo-container {
            position: absolute;
            left: 0;
            top: 7.2%;
            width: 100%;

            .sec1-logo {
                z-index: 1;
                height: 60px;
                width: 120px;
                background-size: contain;
                background-position: center;

                &.iq {
                    background-image: url('../assets/logos/iq/iq_shad2.png');
                }
                &.td {
                    background-image: url('../assets/logos/today/td.png');
                }
                &.av {
                    background-image: url('../assets/logos/avenues/av.png');
                }
                &.pe {
                    background-image: url('../assets/logos/people/pe_shad2.png');
                }
            }
        }

        .det-header {
            width: 50%;
            margin-left: 8%;
            margin-bottom: 2.5%;
            z-index: 3;

            .det-title {
                font-size: 11em;
                letter-spacing: -8px;
            }
            .det-subtitle {
                font-size: 1.5em;
                margin: -60px 0 20px;
            }
        }

        .det-breadcrum{
            position: absolute;
            left: 8%;
            top: 2%;
            height: 50px;
        }
    }

    .det-sec {
        padding: 125px 0;

        .right-section {
            padding: 0 0% 
        }

        .abs2-title {
            font-size: 3.5em;
            line-height: 70px;
            word-wrap: break-word;
        }
    }

    .tablet {
        .lp-sec1 {
            height: 75vh;
            /* background: rgb(239,239,239);
            background: linear-gradient(331deg, rgba(239,239,239,1) 8%, rgba(146,148,154,1) 100%); */
            background: rgb(173,20,87);
            background: linear-gradient(331deg, rgba(173,20,87,1) 0%, rgba(26,35,126,1) 100%);
            overflow: hidden;

            .lp-img {
                position: absolute;
                left: 55%;
                height: 65%;
                width: 40%;
                top: 20%;
            }

            .lp-header {
                width: 50%;
                margin-left: 8%;
                margin-bottom: 2.5%;

                .lp-name {
                    font-size: 8.2em;
                    letter-spacing: -8px;
                }
                .lp-pos {
                    font-size: 1em;
                    margin: -40px 0 20px;
                }
            }

            .lp-breadcrum{
                position: absolute;
                left: 8%;
                top: 2%;
                height: 50px;
            }
        }

        .lp-sec2 {
            padding: 125px 0;

            .right-section {
                padding: 0 0% 
            }

            .abs2-title {
                font-size: 3.5em;
                line-height: 70px;
                word-wrap: break-word;
            }
        }
    }

/////
    .close-btn {
        position: absolute;
        left: 0;
        top: 2%;
        width: 100%;
        height: 50px;
        z-index: 5;
    }
    .breadcrum {
        position: absolute;
        left: 0;
        width: 100%;
        top: 6%;
        height: 50px;
        z-index: 5;
    }

    .prod-bg-top {
        position: absolute;
        width: 100%;
        left: 0;
        height: 100%;
        top: 0;
        overflow: hidden;

        .vid-bg {
            position: absolute;
            height: 100%;
            left: 0;
            top: 0;
            width: 100%;
            opacity: .94;
            z-index: 0;
        }

        .vid-overlay {
            position: absolute;
            height: 100%;
            left: 0;
            top: 0;
            width: 100%;
            opacity: .44; 
            z-index: 1;
        }
    }

    .prod-bg-bonk {
        position: absolute;
        right: -30%;
        margin-top: -8%;
        height: 90%;
        width: 90%;
        transform: rotate(50deg);
        border-radius: 50px;
        opacity: .34;
        z-index: 1;
    }

    .prod-img-sec {
        position: absolute;
        top: 6%;
        right: 4%;
        width: 33%;

        .prod-img {
            position: absolute;
            top: 0%;
            left: 0;
            z-index: 1;
            height: 300px;
            width: 420px;
            background-size: contain;
            background-position: center;

            &.iq {
                background-image: url('../assets/logos/iq/iq_shad2.png');
            }
            &.td {
                background-image: url('../assets/logos/today/td.png');
            }
            &.av {
                background-image: url('../assets/logos/avenues/av.png');
            }
            &.pe {
                background-image: url('../assets/logos/people/pe_shad2.png');
            }
        }
    }
    
    .prod-header {
        position: absolute;
        top: 16%;
        left: 0%;
        width: 100%;
        height: 100%;
        z-index: 3;

        .title-sec {
            position: absolute;
            top: 6%;
            left: 6%;
            width: 50%;

            .prod-title {
                font-size: 10rem;
                line-height: 60px;
                letter-spacing: -8.5px; 
            }

            .prod-subtitle {
                font-size: 1.5em;
                margin-top: 50px;
            }

        }

        .prod-dets {
            position: absolute;
            top: 24%;
            left: 6%;
            width: 40%;
            z-index: 3;

            .prod-desc {
                margin-top: 100px;
                line-height: 40px; 
                width: 90%;
            }

            .prod-highlights {
                width: 60%;
            }
        }

    }

    .prod-links {
        position: absolute;
        right: 4%;
        top: 26%;
        height: 100%;
        width: 40%;
        z-index: 5;
    }

    .prod-vid-sec {
        position: absolute;
        top: 16%;
        width: 100%;
        left: 0%;
        height: 80%;
        z-index: 2; 

        .laptop-mock {
            height: 784px;
            width: 964px;
            background-image: url('../assets/laptop-mock.png');
            background-size: contain;
            background-position: center;

            .preview-frame {
                margin-top: 105px;
                margin-left: 119px;
                height: 450px;
                width: 720px;
                overflow: hidden;
            }
        }
    }
</style>